module.exports = __webpack_public_path__ + "static/monetize-3.1-cb77a941018f013fad4c3e74b6753b4d.png";